var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-tabs", {
    attrs: {
      activeKey: _vm.activeKey
    },
    on: {
      change: _vm.tabChange
    }
  }, [_vm.dashboardFrontPage ? _c("a-tab-pane", {
    key: 1,
    attrs: {
      tab: _vm.$t("首页")
    }
  }, [_c("custom", {
    key: _vm.timer1,
    ref: "customRef",
    attrs: {
      frontPage: _vm.frontPage
    },
    on: {
      ok: _vm.jumpFun2,
      setItem: _vm.setItem
    }
  })], 1) : _vm._e(), _vm.dashboardDataBoard ? _c("a-tab-pane", {
    key: 2,
    attrs: {
      tab: _vm.$t("数据看板")
    }
  }, [_c("bulletin-board", {
    key: _vm.timer2,
    ref: "bulletinBoardRef",
    attrs: {
      bulletinBoardList: _vm.bulletinBoardList,
      delList: _vm.delList
    },
    on: {
      back: _vm.jumpFun,
      ok: _vm.jumpFun3,
      setObj: _vm.setObjFun,
      delArr: _vm.delArrFun
    }
  })], 1) : _vm._e()], 1), _c("a-button", {
    staticClass: "marginT20",
    staticStyle: {
      width: "200px",
      "margin-left": "40%"
    },
    attrs: {
      type: "add"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("确认")))])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };